import { Record, List } from 'immutable';

const defaultValues = {
  number: 0,
  stateContentFileId: '',
  created: '',
  createdBy: null,
  updated: '',
  updatedBy: null,
};

export default class DesignVersion extends Record(defaultValues, DesignVersion) {
  constructor(values) {
    super({
      ...values,
    });
  }

  /**
   * Get contentfile name based on replica id
   * @param {Object} contentFile content-file object
   * @returns content-file name to render
   */
  static getContentFile(contentFile) {
    if (contentFile) {
      const { replicaId, replicaName, contentName } = contentFile;
      if (replicaId) {
        return replicaName;
      }
      return contentName;
    }
    return null;
  }
}

export const DesignVersions = (data) => {
  let designVersions = new List();
  if (data) {
    data.forEach((value) => {
      designVersions = designVersions.push(new DesignVersion(value));
    });
  }
  return designVersions;
};
